"use client";

import { IconFilterBy } from "@repo/assets/images";
import { useFilterOptions } from "@repo/lib/hooks/catalog";
import { Button, OffCanvasDrawer } from "@repo/ui";
import { useTranslations } from "next-intl";
import { useCallback, useState } from "react";
const CategoryFilters = ({
  facets,
  isEmpty,
  appliedFilterCount
}) => {
  const t = useTranslations("Common");
  const [openFilters, setOpenFilters] = useState(false);
  const toggleFilters = useCallback(() => {
    setOpenFilters(prev => !prev);
  }, []);
  const {
    clearAllFilters
  } = useFilterOptions();
  return <>
      <Button size="md" onClick={toggleFilters} variant="secondary" className="text-toolbar-filter-active !bg-toolbar-filter-buttonBg flex h-[36px] min-w-[90px] items-center justify-center !px-0 text-base md:h-[44px]" data-sentry-element="Button" data-sentry-source-file="CategoryFilters.jsx">
        <span className="w-5">
          <IconFilterBy className="text-toolbar-activeIcon me-2 fill-current" data-sentry-element="IconFilterBy" data-sentry-source-file="CategoryFilters.jsx" />
        </span>
        {t("Filter")}
      </Button>
      <OffCanvasDrawer open={openFilters} handleClose={toggleFilters} title={t("Filter")} position="left" data-sentry-element="OffCanvasDrawer" data-sentry-source-file="CategoryFilters.jsx">
        <div className="px-4 py-3 text-start">{facets}</div>
        {!isEmpty && <div className="border-toolbar-filter-facetBorder flex items-center border-t px-6 py-3">
            <span className="text-toolbar-heading text-sm">
              {appliedFilterCount} {t("Filters_Applied")}
            </span>
            <Button onClick={clearAllFilters} type="button" variant="primary" className="ms-auto" size="md">
              {t("Clear_All")}
            </Button>
          </div>}
      </OffCanvasDrawer>
    </>;
};
export default CategoryFilters;